import { Component, EventEmitter, HostListener, Output, Input } from '@angular/core';

@Component({
  selector: 'ca-bulk-list-select',
  templateUrl: './bulk-list-select.component.html',
  styleUrls: ['./bulk-list-select.component.scss'],
  standalone: false,
})
export class BulkListSelectComponent {
  @Input()
  delimiters: string[] = ['\r\n', ';', ',', '\t'];

  @Input()
  cls: string = '';

  @Output()
  itemsPasted = new EventEmitter<string[]>();

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const text = (event.clipboardData?.getData('text') || '').trim();
    let tokens: string[] = [text];
    for (const d of this.delimiters) {
      if (text.includes(d)) {
        tokens = text.split(d);
        break;
      }
    }
    tokens = tokens.map(t => t.trim()).filter(t => t !== '');
    if (tokens.length > 0) {
      this.itemsPasted.emit(tokens);
    }
  }
}
